export default {
	name: "select-vehicle-compartments-for-order-modal",
	props: ["orderId", "product", "vehicleId", "showModal", "compartmentsWithAssignedProducts"],
	emits: ["closeModal", "save"],
	data() {
		return {
			vehicleCompartments: [],
			vehicleCompartmentsHeadings: [
				{
					text: "Compartment Name",
					field: "compartmentName"
				},
				{
					text: "Max Capacity",
					field: "maxCapacity"
				},
				{
					text: "Assigned Amount",
					field: "assignedAmount"
				},
				{
					text: "Current Capacity Available",
					field: "currentCapacityAvailable"
				}
			],
			productToAssign: {},
			totalAmountAssignedForProduct: 0,
			totalAmountUnassignedForProduct: 0,
			modalComponentId: "selectVehicleCompartmentsForOrderModal",
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			entireQuantityNotAssignedMessage: null,
		};
	},
	methods: {
		getVehicleCompartments(){
			this.loading = true;
			let request = {
				productId: this.product.productId,
				vehicleId: this.vehicleId,
			};
			console.log("compartmentsWithAssignedProducts", this.compartmentsWithAssignedProducts);
			orderService.getVehicleCompartmentProductsForOrderAssignment(request).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							this.vehicleCompartments = successResponse.data.result;
							this.vehicleCompartments = dataTableHelper.castObjectValues(this.vehicleCompartments);
							this.updateVehicleCompartmentCapacities();
							// for(let i = 0; i < this.vehicleCompartments.length; i++){
							// 	this.vehicleCompartments[i].cannotSelect = this.vehicleCompartments[i].compartmentProduct === null;
							// 	if(this.compartmentsWithAssignedProducts !== null) {
							// 		for (let j = 0; j < this.compartmentsWithAssignedProducts.length; j++) {
							// 			for (let k = 0; k < this.compartmentsWithAssignedProducts[j].selectedCompartments.length; k++) {
							// 				if (this.vehicleCompartments[i].compartmentProduct.vehicleCompartmentProductId === this.compartmentsWithAssignedProducts[j].selectedCompartments[k].vehicleCompartmentProductId) {
							// 					this.vehicleCompartments[i].selected = this.compartmentsWithAssignedProducts[j].orderId === this.orderId;
							// 					this.vehicleCompartments[i].assignedAmount = this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
							// 					this.vehicleCompartments[i].currentCapacityAvailable = this.vehicleCompartments[i].maxCapacity - this.vehicleCompartments[i].assignedAmount;
							// 					this.totalAmountAssignedForProduct += this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
							// 					this.totalAmountUnassignedForProduct -= this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
							// 					console.log("vehicleCompartments", this.vehicleCompartments[i]);
							// 				}
							// 			}
							// 		}
							// 	}
							// 	if(this.vehicleCompartments[i].currentCapacityAvailable === 0){
							// 		this.vehicleCompartments[i].cannotSelect = true;
							// 	}
							// }
							this.loading = false;
						}
					},
					errorResponse => {
						this.loading = false;
						apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.data.responseStatus, errorResponse.data.httpStatusCode, errorResponse.data.message);
					}
			);
			// this.vehicleCompartments = [
			// 	{
			// 		compartmentId: 1,
			// 		compartmentName: "Compartment 1",
			// 		maxCapacity: 1000,
			// 		assignedAmount: 0,
			// 		currentCapacityAvailable: 1000,
			// 		selected: false
			// 	},
			// 	{
			// 		compartmentId: 2,
			// 		compartmentName: "Compartment 2",
			// 		maxCapacity: 1000,
			// 		assignedAmount: 0,
			// 		currentCapacityAvailable: 1000,
			// 		selected: false
			// 	},
			// 	{
			// 		compartmentId: 3,
			// 		compartmentName: "Compartment 3",
			// 		maxCapacity: 1000,
			// 		assignedAmount: 0,
			// 		currentCapacityAvailable: 1000,
			// 		selected: false
			// 	}
			// ];
			//this.loading = true;
			// vehicleService.getVehicleCompartments(this.vehicleId).then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			this.vehicleCompartments = successResponse.data.result;
			// 			this.vehicleCompartments = dataTableHelper.castObjectValues(this.vehicleCompartments);
			// 			this.loading = false;
			// 		}
			// 	},
			// 	errorResponse => {
			// 		this.loading = false;
			// 		apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(errorResponse.data.responseStatus, errorResponse.data.httpStatusCode, errorResponse.data.message);
			// 	}
			// );
		},
		updateVehicleCompartmentCapacities(){
			for(let i = 0; i < this.vehicleCompartments.length; i++){
				this.vehicleCompartments[i].assignedAmountForCurrentOrder = 0;
				this.vehicleCompartments[i].cannotSelect = this.vehicleCompartments[i].compartmentProduct === null;
				if(this.compartmentsWithAssignedProducts !== null) {
					for (let j = 0; j < this.compartmentsWithAssignedProducts.length; j++) {
						for (let k = 0; k < this.compartmentsWithAssignedProducts[j].selectedCompartments.length; k++) {
							if (this.vehicleCompartments[i].compartmentProduct.vehicleCompartmentProductId === this.compartmentsWithAssignedProducts[j].selectedCompartments[k].compartmentProduct.vehicleCompartmentProductId) {
								this.vehicleCompartments[i].selected = this.compartmentsWithAssignedProducts[j].orderId === this.orderId;
								this.vehicleCompartments[i].assignedAmount = this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
								this.vehicleCompartments[i].currentCapacityAvailable = this.vehicleCompartments[i].maxCapacity - this.vehicleCompartments[i].assignedAmount;
								this.vehicleCompartments[i].isAssignedToAnotherOrder = this.compartmentsWithAssignedProducts[j].orderId !== this.orderId;
								if(this.vehicleCompartments[i].selected){
									this.vehicleCompartments[i].assignedAmountForCurrentOrder = this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
									this.totalAmountAssignedForProduct += this.compartmentsWithAssignedProducts[j].selectedCompartments[k].assignedAmount;
									this.totalAmountUnassignedForProduct = this.totalAmountAssignedForProduct - this.product.quantity;
									// if(this.totalAmountUnassignedForProduct === 0){
									// 	this.vehicleCompartments[i].cannotSelect = true;
									// }
								}
								console.log("totalAmountAssignedForProduct", this.totalAmountAssignedForProduct);
								console.log("totalAmountUnassignedForProduct", this.totalAmountUnassignedForProduct);
							}
						}
						if(this.compartmentsWithAssignedProducts[j].orderId === this.orderId && this.totalAmountUnassignedForProduct <= 0 && !this.vehicleCompartments[i].selected){
							this.vehicleCompartments[i].cannotSelect = true;
						}
					}
				}
				if(this.vehicleCompartments[i].currentCapacityAvailable === 0 && this.vehicleCompartments[i].isAssignedToAnotherOrder){
					this.vehicleCompartments[i].cannotSelect = true;
				}
			}
		},
		onCompartmentSelect(compartmentProduct){
			console.log("onCompartmentSelect", compartmentProduct);
			let compartment = this.vehicleCompartments.find(compartment => compartment.compartmentProduct.vehicleCompartmentId === compartmentProduct.vehicleCompartmentId);
			compartment.selected = !compartment.selected;
			if(this.totalAmountUnassignedForProduct === 0 && compartment.selected){
				return;
			}
			
			if(compartment.selected){
				// var amountUnassigned = this.productToAssign.quantity - compartment.currentCapacityAvailable;
				var amountUnassigned = 0;
				var amountAssigned = this.totalAmountUnassignedForProduct;
				
				if(this.totalAmountUnassignedForProduct > compartment.currentCapacityAvailable) {
					amountUnassigned = this.totalAmountUnassignedForProduct - compartment.currentCapacityAvailable;
				}
				else{
					amountUnassigned = compartment.currentCapacityAvailable - this.totalAmountUnassignedForProduct;
				}
				
				// amountUnassigned = this.totalAmountUnassignedForProduct - compartment.currentCapacityAvailable;
				// if(amountUnassigned < 0){
				// 	amountUnassigned = amountUnassigned * -1;
				// }
				if(this.totalAmountUnassignedForProduct === amountUnassigned ){
					amountAssigned = this.totalAmountUnassignedForProduct;
				}
				else if(this.totalAmountUnassignedForProduct < compartment.currentCapacityAvailable){
					amountAssigned = this.totalAmountUnassignedForProduct;
				}
				else {
					amountAssigned = this.totalAmountUnassignedForProduct - amountUnassigned;
				}
				console.log("amountUnassigned", amountUnassigned);
				
				this.totalAmountAssignedForProduct += amountAssigned;
				this.totalAmountUnassignedForProduct -= amountAssigned;
				compartment.assignedAmount += amountAssigned;
				compartment.assignedAmountForCurrentOrder += amountAssigned;
				compartment.currentCapacityAvailable = compartment.maxCapacity - compartment.assignedAmount;
				compartment.isAssignedToAnotherOrder = false;
				console.log("totalAmountAssignedForProduct", this.totalAmountAssignedForProduct);
				console.log("totalAmountUnassignedForProduct", this.totalAmountUnassignedForProduct);
			}
			else{
				this.totalAmountAssignedForProduct -= compartment.assignedAmountForCurrentOrder;
				this.totalAmountUnassignedForProduct += compartment.assignedAmountForCurrentOrder;
				compartment.currentCapacityAvailable += compartment.assignedAmountForCurrentOrder;
				compartment.assignedAmount -= compartment.assignedAmountForCurrentOrder;
				compartment.assignedAmountForCurrentOrder -= compartment.assignedAmountForCurrentOrder;
			}

			for(let i = 0; i < this.vehicleCompartments.length; i++){
				if(this.totalAmountUnassignedForProduct <= 0 && !this.vehicleCompartments[i].selected){
					this.vehicleCompartments[i].cannotSelect = true;
				}
				else{
					this.vehicleCompartments[i].cannotSelect = false;
				}

				if(this.vehicleCompartments[i].currentCapacityAvailable === 0 && this.vehicleCompartments[i].isAssignedToAnotherOrder){
					this.vehicleCompartments[i].cannotSelect = true;
				}
			}
		},
		onModalCloseClick(){
			this.totalAmountAssignedForProduct = 0;
			this.totalAmountUnassignedForProduct = 0;
			// this.vehicleCompartments = [];
			this.$emit("closeModal");
		},
		onSaveClick(){
			console.log("onSaveClick");
			if(this.totalAmountUnassignedForProduct > 0) {
				this.entireQuantityNotAssignedMessage = "The entire quantity for this product has not been assigned to compartments.";
			}
			else{
				this.entireQuantityNotAssignedMessage = null;
				var selectedCompartments = this.vehicleCompartments.filter(compartment => compartment.selected);
				this.totalAmountAssignedForProduct = 0;
				this.totalAmountUnassignedForProduct = 0;
				this.$emit("save", selectedCompartments);
			}
		}
	},
	mounted: function () {
		
	},
	watch:{
		vehicleId:{
			handler: function () {
				console.log("vehicleId", this.vehicleId);
				// if(this.vehicleId !== null && this.vehicleId > 0){
				// 	this.getVehicleCompartments();
				// }
			},
			immediate: true,
			deep: true
		},
		product:{
			handler: function () {
				console.log("product", this.product);
				if(this.product !== null){
					this.productToAssign = this.product;
					this.totalAmountUnassignedForProduct = this.product.quantity;
					//this.getVehicleCompartments();
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				console.log("showModal", this.showModal);
				if(this.showModal){
					$("#" + this.modalComponentId).modal("show");
					this.getVehicleCompartments();
					//this.updateVehicleCompartmentCapacities();
				}
				else{
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};